import { useTranslation } from "react-i18next"

import ModalService from "src/modals"

import "./PlayerCardButton.css"

/* A player's picture as the door to their card (`PlayerCardModal`). It wraps whatever draws the
   picture — the frame, the image — and adds nothing to its look but a pointer and a focus ring.

   `user` is the payload's user and `picture` the avatar id the caller drew, so the card shows the
   same face. A bot is in no ranking and has no card: its picture is drawn as it was. The header's
   own picture is not one of these — it opens the settings (owner, 2026-10-09). */
const PlayerCardButton = ({ user, picture, className = "", children }) => {
  const { t } = useTranslation()
  if (!user || user.isBot || user.is_bot) return children
  const label = t("playerCard.open", { name: user.username })
  return (
    <button
      type="button"
      className={`player-card-button ${className}`.trim()}
      onClick={(event) => {
        event.stopPropagation()
        ModalService.show("PlayerCardModal", { user, picture })
      }}
      title={label}
      aria-label={label}
    >
      {children}
    </button>
  )
}

export default PlayerCardButton
